import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListaAppuntamentiComponent } from './companies/ListaAppuntamenti/lista-appuntamenti.component';
import { FullLayoutComponent } from './containers';
import { AuthGuard } from './guards/AuthGuard';
import { ProfiloComponent } from './portale/Profilo/profilo.component';
import { P404Component } from './views/pages/404.component';
import { P503Component } from './views/pages/503.component';

const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('./views/pages/pages.module').then((m) => m.PagesModule),
	},
	{
		path: 'login_due_fattori',
		loadChildren: () => import('./views/pages/pages.module').then((m) => m.PagesModule),
	},
	{
		path: 'reset_password',
		loadChildren: () => import('./portale/reset_password/reset_password.module').then((m) => m.ResetPasswordModule),
	},
	{
		path: '',
		canActivate: [AuthGuard],
		component: FullLayoutComponent,
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full',
			},
			{
				path: 'dashboard',
				loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
			},
			{
				path: 'portale',
				loadChildren: () => import('./portale/portale.module').then((m) => m.PortaleModule),
				data: {
					title: '',
				},
			},
			{
				path: 'sezione_documentale',
				loadChildren: () => import('./sezione-documentale/sezione-documentale.module').then((m) => m.SezioneDocumentalePageModule),
			},
			{
				path: 'companies',
				loadChildren: () => import('./companies/companies.module').then((m) => m.CompaniesModule),
				data: {
					title: 'Aziende',
				},
			},
			{
				path: 'mail',
				loadChildren: () => import('./mail/mail.module').then((m) => m.MailModule),
				data: {
					title: 'Email',
				},
			},
			{
				path: 'mail-settings',
				loadChildren: () => import('./mail/settings/mail-settings.module').then((m) => m.MailSettingsModule),
				data: {
					title: 'Impostazioni Email',
				},
			},
			{
				path: 'worksite',
				loadChildren: () => import('./companies/Worksite/worksite.module').then((m) => m.WorksiteModule),
			},
			{
				path: 'gare',
				loadChildren: () => import('./companies/Gare/gare.module').then((m) => m.GareModule),
			},
			{
				path: 'appointments',
				component: ListaAppuntamentiComponent,
			},
			{
				path: 'records',
				loadChildren: () => import('./companies/Attendance/attendance.module').then((m) => m.AttendanceModule),
				data: {
					title: '',
				},
			},
			{
				path: 'records',
				loadChildren: () => import('./companies/Attendance/attendance.module').then((m) => m.AttendanceModule),
				data: {
					title: '',
				},
			},
			{
				path: 'workflow',
				loadChildren: () => import('./workflow/workflow.module').then((m) => m.WorkflowModule),

				data: {
					title: '',
				},
			},
			{
				path: 'activity',
				loadChildren: () => import('./activity/activity.module').then((m) => m.ActivityModule),
				data: {
					title: '',
				},
			},
			{
				path: 'instance',
				loadChildren: () => import('./instance/instance.module').then((m) => m.InstanceModule),
				data: {
					title: '',
				},
			},
			{
				path: 'report',
				loadChildren: () => import('./report_utility/report-utility.module').then((m) => m.ReportUtilityModule),
				data: {
					title: '',
				},
			},
			{
				path: 'ticketsrfi',
				loadChildren: () => import('./helpdesk_rfi/tickets/tickets.module').then((m) => m.TicketsModule),
				data: {
					title: '',
				},
			},
			{
				path: 'profile',
				component: ProfiloComponent,
				data: {
					title: 'Profilo',
				},
			},
			{
				path: 'hr',
				loadChildren: () => import('./HR/hr.module').then((m) => m.HRModule),
				data: {
					title: '',
				},
			},
			{
				path: 'automezzi',
				loadChildren: () => import('./automezzi/automezzi.module').then((m) => m.AutomezziModule),
				data: {
					title: 'Automezzi',
				},
			},
			{
				path: 'magazzino',
				loadChildren: () => import('./magazzino/magazzino.module').then((m) => m.MagazzinoModule),
				data: {
					title: 'Magazzino',
				},
			},
			{
				path: 'fatture',
				loadChildren: () => import('./fatture/fatture.module').then((m) => m.FattureModule),
				data: {
					title: 'Fatture',
				},
			},
			{
				path: 'documenti',
				loadChildren: () => import('./documenti/documenti.module').then((m) => m.DocumentiModule),
				data: {
					title: 'Documenti',
				},
			},
			{
				path: 'biz-appointments',
				loadChildren: () => import('./biz-appointments/biz-appointments.module').then((m) => m.BizAppointmentsModule),
				data: {
					title: 'Appuntamenti',
				},
			},
			{
				path: 'messaging',
				loadChildren: () => import('./messaging/messaging.module').then((m) => m.MessagingModule),
				data: {
					title: 'Messaggi',
				},
			},
			{
				path: 'notifications',
				loadChildren: () => import('./notifications/notifications.module').then((m) => m.NotificationsModule),
				data: {
					title: 'Notifiche',
				},
			},
			{
				path: 'style-guide',
				loadChildren: () => import('./style-guide/style-guide.module').then((m) => m.StyleGuideModule),
				data: {
					title: 'Style Guide',
				},
			},
			{
				path: 'prenotazioni',
				loadChildren: () => import('./prenotazioni/prenotazioni.module').then((m) => m.PrenotazioniModule),
				data: {
					title: 'Prenotazioni',
				},
			},
			{
				path: 'pagamento',
				loadChildren: () => import('./pagamento/pagamento.module').then((m) => m.PagamentoModule),
				data: {
					title: 'Pagamento',
				},
			},
			{
				path: 'cel',
				loadChildren: () => import('./companies/Cel/cel.module').then((m) => m.CelModule),
				data: {
					title: 'CEL',
				},
			},
			{
				path: 'sub-aff',
				loadChildren: () => import('./companies/SubAff/sub-aff.module').then((m) => m.SubAffModule),
				data: { title: 'Sub-Affidamenti' },
			},
			{
				path: 'sal',
				loadChildren: () => import('./companies/Sal/sal.module').then((m) => m.SalModule),
				data: { title: 'SAL' },
			},
			{
				path: 'sal-passivo',
				loadChildren: () => import('./companies/SalPassivo/sal-passivo.module').then((m) => m.SalPassivoModule),
				data: { title: 'SAL Passivi' },
			},
			{
				// Cert. Pagamento — modulo unificato: stesso componente del flusso RFI
				// ma con mode='portale' → backend federato (ws_spring_cmp/cert-payment) e vista federata
				path: 'cert-payment',
				loadChildren: () => import('./helpdesk_rfi/tickets/certificati_pagamento/certificati_pagamento.module').then((m) => m.CertificatiPagamentoModule),
				data: { title: 'Certificati Pagamento', mode: 'portale' },
			},

		],
	},
	{
		path: '404',
		component: P404Component,
	},
	{
		path: '503',
		component: P503Component,
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
